module.exports = __webpack_public_path__ + "19ef5c7c495a5a59dd1d2175eadef84f.svg";